import HttpClient from '@/common/boot/HttpClient'

const listarTratativas = async ({ commit }, payload = {}) => {
  commit('BUSCANDO', true)
  try {
    const params = {
      trashed: payload?.mostrarExcluidos ? true : false
    };
    const response = await HttpClient.get('/ctrl-tratativas', { params })
    const data = response.data?.data
    commit('LISTAR_TRATATIVAS', data)
    return response
  } finally {
    commit('BUSCANDO', false)
  }
}

const salvarTratativa = async ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true)
  try {
    const response = await HttpClient.post('/ctrl-tratativas', payload)
    await dispatch('listarTratativas')
    return response
  } finally {
    commit('BUSCANDO', false)
  }
}

const atualizarTratativa = async ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true)
  try {
    const response = await HttpClient.put(`/ctrl-tratativas/${payload.id}`, payload)
    await dispatch('listarTratativas')
    return response
  } finally {
    commit('BUSCANDO', false)
  }
}

const excluirTratativa = async (_, item) => {
  return HttpClient.delete(`/ctrl-tratativas/${item.id}`)
}

const excluirTratativas = async ({ dispatch }, payload) => {
  for (const item of payload) {
    await excluirTratativa(null, item)
  }
  await dispatch('listarTratativas')
}

const restaurarTratativa = async ({ commit, dispatch }, payload) => {
  commit('BUSCANDO', true)
  try {
    const response = await HttpClient.post(`/ctrl-tratativas/${payload}/restaurar`)
    await dispatch('listarTratativas')
    return response
  } finally {
    commit('BUSCANDO', false)
  }
}

export {
  listarTratativas,
  salvarTratativa,
  atualizarTratativa,
  excluirTratativa,
  excluirTratativas,
  restaurarTratativa
}